<template>
    <div class="storiesBlock">
        <div
            class="storiesWrapper"
            :class="{
                hide: showVideo
            }"
        >
            <span class="badge red">New</span>
            <h1 class="blockTitle">Stories</h1>
            <!-- <p class="blockSubTitle">Coming soon...</p> -->
            <p class="blockDescription">Everyone has their own story. To bring our members even closer without border limits, we are collaborating with YouTubers creating a new segment called "Stories" which will be released monthly. Please subscribe below to get notified.</p>
            
            <!-- <a v-if="!subscribed" href="#0" @click.prevent="subscribe" class="btn green icon-left"><ion-icon name="notifications"></ion-icon> Subscribe</a>
            <p v-else class="successMsg"><ion-icon name="notifications"></ion-icon> You have successfully subscribed.</p> -->

            <router-link to="/stories" class="btn green">Watch Stories</router-link>
        </div>

        <div v-if="showVideo" class="backgroundVideo">
            <video src="https://prismic-io.s3.amazonaws.com/vanmglcom/9ac352eb-6057-431b-8855-ca8775a4c20f_One+Mgl+Intro.mp4" muted autoplay playsinline></video>
        </div>
    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
    data(){
        return{
            subscribed: false,
            allSubscribedUsers: null,
            showVideo: false
        }
    },
    
    mounted(){
        this.getAllSubscribed()
    },

    created(){            
        this.doAnimation()
    },

    methods: {
        getAllSubscribed(){

            let storiesRef = fb.storiesCollection.doc('subscribed')
    
            storiesRef.get().then(snap => {
                if(snap){
                    let allSubscribedUsers = snap.data()

                    this.allSubscribedUsers = allSubscribedUsers

                    if(this.allSubscribedUsers[this.$store.state.currentUser.uid] === true){
                        this.subscribed = true
                    }
                }else{
                    console.log('No subscribed users found!')
                }
            })
            .catch(err => {
                console.log('Error getting all subscribed users.')
            })
        },
        subscribe(){
            if(this.$store.state.currentUser === null){
                
                alert('Please login to subscribe!')

                this.$router.push('/login')

            }else if(!this.subscribed){

                let storiesRef = fb.storiesCollection.doc('subscribed')
                let updates = {}

                updates[this.$store.state.currentUser.uid] = true
                
                storiesRef.update(updates).then(() => {
                    this.$notify({
                        group: 'globalNotifications',
                        title: 'Successfully subscribed to OneMgl Stories.'
                    })
                    this.subscribed = true
                })
                .catch(err => {
                    console.log('Error subscribing user: ', this.$store.state.currentUser.uid)
                })
            }
        },
        doAnimation(){
            setTimeout(() => {
                this.showVideo = true

                setTimeout(() => {
                    this.showVideo = false
                }, 6000)
            }, 2000)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Stories.vue